
<footer :class="['Footer', { 'Footer--no-background': noBackground }]">
    <div class="FooterContainer">
        <div class="FooterTop">
            <div class="BrandSection">
                <router-link to="/" class="Logo">
                    <img src="../assets/svg/logo.svg" alt="TaxiFusion Logo" />
                </router-link>
                <p class="BrandTagline">
                    Die moderne Lösung für Taxi- und Mietwagenunternehmen
                </p>
                <div class="SocialIcons">
                    <a
                        href="https://www.facebook.com/taxifusion"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Facebook"
                        class="SocialIcon"
                    >
                        <i class="ri-facebook-fill"></i>
                    </a>
                    <a
                        href="https://www.linkedin.com/company/taxifusion-de"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn"
                        class="SocialIcon"
                    >
                        <i class="ri-linkedin-fill"></i>
                    </a>
                </div>
            </div>

            <nav class="FooterNavigation">
                <div class="NavCol">
                    <h3>Produkt</h3>
                    <ul>
                        <li>
                            <component
                                :is="isLandingPage ? 'a' : 'router-link'"
                                :href="isLandingPage ? getLinkHref('features') : undefined"
                                :to="!isLandingPage ? getLinkHref('features') : undefined"
                                @click="
                                    isLandingPage
                                        ? handleAnchorClick($event, 'features')
                                        : undefined
                                "
                            >
                                Features
                            </component>
                        </li>
                        <li>
                            <component
                                :is="isLandingPage ? 'a' : 'router-link'"
                                :href="isLandingPage ? getLinkHref('pricing') : undefined"
                                :to="!isLandingPage ? getLinkHref('pricing') : undefined"
                                @click="
                                    isLandingPage
                                        ? handleAnchorClick($event, 'pricing')
                                        : undefined
                                "
                            >
                                Preise
                            </component>
                        </li>
                        <li>
                            <router-link to="/webinar">Webinar</router-link>
                        </li>
                        <li>
                            <router-link to="/exclusive-offers">Exklusive Angebote</router-link>
                        </li>
                        <li><router-link to="/sign-in">Login</router-link></li>
                    </ul>
                </div>

                <div class="NavCol">
                    <h3>TaxiFusion</h3>
                    <ul>
                        <li>
                            <router-link to="/blog" @click.native="trackBlogClick"
                                >Blog</router-link
                            >
                        </li>
                        <li>
                            <component
                                :is="isLandingPage ? 'a' : 'router-link'"
                                :href="isLandingPage ? getLinkHref('contact') : undefined"
                                :to="!isLandingPage ? getLinkHref('contact') : undefined"
                                @click="
                                    isLandingPage
                                        ? handleAnchorClick($event, 'contact')
                                        : undefined
                                "
                            >
                                Kontakt
                            </component>
                        </li>
                        <li>
                            <router-link to="/privacy-policy">Datenschutzerklärung</router-link>
                        </li>
                        <li>
                            <router-link to="/terms-of-service"
                                >Geschäftsbedingungen</router-link
                            >
                        </li>
                        <li><router-link to="/impressum">Impressum</router-link></li>
                    </ul>
                </div>

                <div class="NavCol ContactCol">
                    <h3>Kontakt</h3>
                    <div class="ContactInfo">
                        <div class="ContactItem">
                            <i class="ri-mail-line"></i>
                            <a href="mailto:support@taxifusion.de">support@taxifusion.de</a>
                        </div>
                        <div class="ContactItem">
                            <i class="ri-phone-line"></i>
                            <a href="tel:+4930959982020">030 959982020</a>
                        </div>
                        <div class="ContactItem">
                            <i class="ri-map-pin-line"></i>
                            <a
                                href="https://maps.google.com/?q=Karl-Marx-Str.+248,+12057+Berlin"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Karl-Marx-Str. 248<br />
                                12057 Berlin
                            </a>
                        </div>
                    </div>
                </div>
            </nav>
        </div>

        <div class="FooterBottom">
            <div class="Copyright">
                <p>&copy; {{ currentYear }} TaxiFusion. Alle Rechte vorbehalten.</p>
            </div>
            <div class="LegalLinks">
                <router-link to="/privacy-policy">Datenschutz</router-link>
                <span class="Divider">|</span>
                <router-link to="/terms-of-service">AGB</router-link>
                <span class="Divider">|</span>
                <router-link to="/impressum">Impressum</router-link>
            </div>
        </div>
    </div>

    <div class="FooterBackground">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 320"
            preserveAspectRatio="none"
        >
            <path
                fill="rgba(255,255,255,0.03)"
                d="M0,224L60,213.3C120,203,240,181,360,181.3C480,181,600,203,720,224C840,245,960,267,1080,266.7C1200,267,1320,245,1380,234.7L1440,224L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"
            ></path>
        </svg>
    </div>
</footer>
